import { getType } from 'typesafe-actions';
import { produce } from 'immer';

import { ActionsOf } from '../../../helpers/actions';
import * as sitesActions from './actions';

import { Site, SitesData } from 'src/components/modules/sites/types';

import { ApiError } from 'src/api/types';

const initialState: SitesData = {
  items: [],
  loading: false,
  pageNumber: 0,
  totalItems: 0,
  error: false,
  success: false,
};

type SitesActions = ActionsOf<typeof sitesActions>;

export const sitesEntityReducer = produce((draft: SitesData, action: SitesActions) => {
  switch (action.type) {
    case getType(sitesActions.getSites.success): {
      const { result } = action.payload as { result: SitesData };

      draft.items = result.items;
      draft.pageNumber = result.pageNumber;
      draft.totalItems = result.totalItems;
      draft.loading = false;
      draft.error = false;

      return;
    }

    case getType(sitesActions.getSites.request): {
      draft.loading = true;
      draft.success = false;
      draft.error = false;

      return;
    }

    case getType(sitesActions.getSites.error): {
      draft.loading = false;
      draft.error = true;

      return;
    }

    case getType(sitesActions.editSite.request): {
      draft.saving = true;
      draft.error = false;
      draft.success = false;

      return;
    }

    case getType(sitesActions.editSite.error): {
      const payload = action.payload as { error?: ApiError };

      if (payload?.error?.message) {
        const errorMessage = JSON.parse(payload.error.message);
        draft.error = errorMessage[0];
      } else {
        draft.error = true;
      }

      draft.saving = false;
      return;
    }

    case getType(sitesActions.editSite.success): {
      const { result } = action.payload as { result: Site };
      const index = draft.items.findIndex((site) => site.id === result.id);

      if (index !== -1) {
        draft.items[index] = { ...draft.items[index], ...result };
      }

      draft.saving = false;
      draft.success = true;
      draft.error = false;

      return;
    }

    default:
      return;
  }
}, initialState);
